import React, { useState, useEffect } from "react";
import { Shield, ChevronDown, ChevronUp } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true,
    analytical: true,
    marketing: true,
  });

  useEffect(() => {
    const consent = localStorage.getItem("medoel_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    const consentData = {
      accepted: true,
      essential: true,
      analytical: true,
      marketing: true,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem("medoel_cookie_consent", JSON.stringify(consentData));
    setShow(false);
  };

  const handleAcceptEssential = () => {
    const consentData = {
      accepted: true,
      essential: true,
      analytical: false,
      marketing: false,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem("medoel_cookie_consent", JSON.stringify(consentData));
    setShow(false);
  };

  const handleSavePreferences = () => {
    const consentData = {
      accepted: true,
      ...preferences,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem("medoel_cookie_consent", JSON.stringify(consentData));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[100] animate-in slide-in-from-bottom-5 duration-500">
      <div className="glass-strong rounded-3xl p-6 shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10 text-white font-body">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-xl bg-lime-brand/10 border border-lime-brand/35 flex items-center justify-center shrink-0">
            <Shield className="w-5 h-5 text-lime-brand" />
          </div>
          <div>
            <h4 className="font-heading font-bold text-lg text-white">Cookie-Einstellungen</h4>
            <p className="mt-2 text-sm text-white/70 leading-relaxed">
              Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern, den Traffic zu analysieren und relevante Inhalte anzuzeigen.
            </p>
          </div>
        </div>

        {showDetails && (
          <div className="mt-4 pt-4 border-t border-white/10 space-y-3">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-semibold text-white">Essenziell</div>
                <div className="text-xs text-white/50">Erforderlich für die Grundfunktionen der Website.</div>
              </div>
              <input type="checkbox" checked disabled className="rounded border-ink-400 text-lime-brand focus:ring-lime-brand w-4 h-4 accent-lime-brand" />
            </div>

            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-semibold text-white">Statistiken & Analyse</div>
                <div className="text-xs text-white/50">Hilft uns zu verstehen, wie Besucher mit der Website interagieren.</div>
              </div>
              <input
                type="checkbox"
                checked={preferences.analytical}
                onChange={(e) => setPreferences({ ...preferences, analytical: e.target.checked })}
                className="rounded border-ink-400 text-lime-brand focus:ring-lime-brand w-4 h-4 accent-lime-brand cursor-pointer"
              />
            </div>

            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-semibold text-white">Marketing</div>
                <div className="text-xs text-white/50">Ermöglicht personalisierte Angebote und externe Services wie Google Maps.</div>
              </div>
              <input
                type="checkbox"
                checked={preferences.marketing}
                onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
                className="rounded border-ink-400 text-lime-brand focus:ring-lime-brand w-4 h-4 accent-lime-brand cursor-pointer"
              />
            </div>
          </div>
        )}

        <div className="mt-5 flex items-center justify-between gap-3 text-xs text-white/60">
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="flex items-center gap-1 hover:text-white transition font-heading font-semibold uppercase tracking-wider"
          >
            {showDetails ? (
              <>
                Details ausblenden <ChevronUp className="w-3.5 h-3.5" />
              </>
            ) : (
              <>
                Details anzeigen <ChevronDown className="w-3.5 h-3.5" />
              </>
            )}
          </button>
        </div>

        <div className="mt-5 flex flex-col gap-2.5">
          <button
            onClick={handleAcceptAll}
            className="w-full py-3 rounded-full bg-precision-brand text-ink-900 font-heading font-bold uppercase text-xs tracking-widest hover:scale-[1.02] hover:shadow-[0_0_20px_rgba(57,255,20,0.3)] transition duration-200"
          >
            Alle akzeptieren
          </button>

          {showDetails ? (
            <button
              onClick={handleSavePreferences}
              className="w-full py-3 rounded-full bg-ink-700/60 border border-ink-400 text-white font-heading font-semibold uppercase text-xs tracking-widest hover:bg-ink-600 transition"
            >
              Auswahl speichern
            </button>
          ) : (
            <button
              onClick={handleAcceptEssential}
              className="w-full py-3 rounded-full bg-ink-700/60 border border-ink-400 text-white/80 font-heading font-semibold uppercase text-xs tracking-widest hover:bg-ink-600 hover:text-white transition"
            >
              Nur essenzielle
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
